import React, { useEffect, useState } from 'react';
import { Box, Typography } from '@mui/material';
import PortalDataGridPro from '../../common/PortalDataGridPro';
import { getColumns } from './columns';
import { WithSmallScreen } from '../../common/WithSmallScreen';
import { ats } from '../../../DataAccessLayer/services';
import { getData } from '../../../DataAccessLayer';
import { getCourseMenu } from './actionsMenu';
import { FooterActionBar } from '../../common/DataTable/FooterActionBar';
import { BulkActionMenu } from './BulkActionMenu';
import Loader from '../../common/Loader';
import ActionDialogs from './ActionDialogs';
import PortalAlert from '../../common/PortalAlert';
import ApiErrorMessage from '../../common/ApiErrorMessage';

export const Datatable = WithSmallScreen(({ id, isNextTerm = false, ...props }) => {
  const [courses, setCourses] = useState([]);
  const [codecs, setCodecs] = useState([]);
  const [selectionModel, setSelectionModel] = useState({});
  const [selectedCourse, setSelectedCourse] = useState();
  const [courseActionMenu, setCourseActionMenu] = useState();
  const [bulkActionMenu, setBulkActionMenu] = useState();
  const [isLoading, setIsLoading] = useState(true);
  const [isError, setIsError] = useState(false);
  const [isCodecsLoaded, setIsCodecsLoaded] = useState(false);
  const [pinned, setPinned] = useState({
    left: ['edit', 'select', 'TYPE', 'CRN', 'codecs'],
  });

  const loadPage = async () => {
    try {
      toggleIsLoading(true);
      toggleIsError(false);
      const data = await loadCourses();
      if (data.length) {
        if (!isCodecsLoaded) {
          setCodecs((await getData(ats.codecs)) ?? []);
          setIsCodecsLoaded(true);
        }
      }
    } catch (err) {
      console.log(err);
      toggleIsError(true);
    } finally {
      toggleIsLoading(false);
    }
  };

  useEffect(() => {
    loadPage();
  }, []);

  const loadCourses = async () => {
    const data = await getData(ats.courses(isNextTerm), true);
    setCourses(data);
    return data;
  };

  const onPinnedChange = (pinned) => {
    setPinned(pinned);
  };

  const toggleIsLoading = (isLoading) => {
    setIsLoading(isLoading);
  };

  const toggleIsError = (value) => {
    setIsError(value);
  };

  return (
    <>
      <Loader id={`${id}__loader`} isOpen={!courseActionMenu || !bulkActionMenu} />

      <ActionDialogs
        id={id}
        selectedCourse={selectedCourse}
        selectionModel={selectionModel}
        setSelectedCourse={setSelectedCourse}
        setCourseActionMenu={setCourseActionMenu}
        setBulkActionMenu={setBulkActionMenu}
        isCourseListActionsMenu={true}
        codecs={codecs}
        isSmall={props.isSmall}
        loadCourses={loadCourses}
      />

      {courseActionMenu && bulkActionMenu && (
        <>
          <Box id={`${id}__box_dataGridOuterWrapper`} className="dataTable" mt={2}>
            {!isLoading && isError && (
              <Box mb={2}>
                <PortalAlert id={`${id}__portalAlert`} severity="error">
                  <ApiErrorMessage
                    id={`${id}__apiErrorMessage`}
                    reload={loadPage}
                    widgetName="Courses"
                    isPage={true}
                  />
                </PortalAlert>
              </Box>
            )}

            <Box className="outer" id={`${id}__box_dataGridInnerWrapper`}>
              <PortalDataGridPro
                className="myOdu__resultTable inner"
                id={`${id}__dataGrid`}
                isLoading={isLoading}
                rows={courses}
                columns={getColumns({
                  id,
                  courses,
                  selectionModel,
                  setSelectionModel,
                  courseMenu: getCourseMenu(courseActionMenu),
                })}
                getRowId={(row) => row.CRN}
                autoHeight
                initialState={{
                  sorting: {
                    sortModel: [
                      {
                        field: 'TYPE',
                        dir: 'desc',
                      },
                      { field: 'CRN', dir: 'asc' },
                    ],
                  },
                  pagination: {
                    paginationModel: { pageSize: 20 },
                  },
                }}
                pagination
                pinnedColumns={props.isSmall || props.isMD || props.isLG ? {} : pinned}
                onPinnedColumnsChange={onPinnedChange}
                getRowHeight={(params) => {
                  return 'auto';
                }}
                disableRowSelectionOnClick
                slotProps={{
                  loadingOverlay: {
                    noRowsVariant: 'skeleton',
                  },
                }}
                slots={{
                  noRowsOverlay: () => {
                    return (
                      <Box
                        mt={1}
                        display="flex"
                        justifyContent="center"
                        id={`${id}__box_noResultsWrapper`}
                      >
                        <Typography variant="p" component="p" id={`${id}__p_noResults`}>
                          No course records found.
                        </Typography>
                      </Box>
                    );
                  },
                }}
              />
            </Box>
          </Box>
          <FooterActionBar
            selectedItemsCount={Object.keys(selectionModel).length}
            onClose={() => {
              setSelectionModel({});
            }}
            actionComponents={
              <BulkActionMenu
                id={`${id}BulkAction`}
                isLoading={isLoading}
                selectionModel={selectionModel}
                actions={getCourseMenu(bulkActionMenu)}
              />
            }
            id={id}
          />
        </>
      )}
    </>
  );
});
